/* Vitamin B12 Drops for Cats on the oc-ph-hw-v1 page layout. One-time only (the product has no selling plan), sold as
   1, 2 or 3 bottles of its one variant, exactly as the range page sold it on 28 Oct 2026. The 2- and 3-bottle prices
   come from the store's automatic discounts "Vitamin B12 Drops 2-pack savings" (7.12% off at 2 or more) and
   "3-pack savings" (14.27% off at 3 or more). Shopify takes the better one, per bottle, rounded down, so a pack costs
   bottles x (price - floor(price x rate)): US$34.99 / US$65.00 / US$90.00 and A$55.00 / A$102.18 / A$141.48, checked
   against Storefront API carts. Adds use the range page's line format (variant, quantity, `_oc_range_page`) plus this
   page's own tags, then the cart is read back and the add is undone if the cart costs more than this page showed. */
(() => {
  'use strict';
  const root = document.querySelector('[data-oc-hw-native]');
  if (!root) return;
  const cfg = JSON.parse(root.querySelector('[data-hw-config]').textContent);
  const decoder = document.createElement('textarea');
  Object.keys(cfg.strings).forEach(key => {decoder.innerHTML=cfg.strings[key];cfg.strings[key]=decoder.value;});
  const params = new URLSearchParams(location.search);
  const form = root.querySelector('[data-hw-purchase]');
  const button = form.querySelector('[data-hw-add]');
  const label = button.querySelector('[data-hw-add-label]');
  const offerRoot = root.querySelector('[data-hw-offers]');
  const status = root.querySelector('[data-hw-status]');
  const radios = [...root.querySelectorAll('[name="oc-hw-pack"]')];
  let busy = false, uncertain = false;

  const formatter = new Intl.NumberFormat('en-US', {style:'currency',currency:cfg.currency});
  const money = cents => formatter.format(cents / 100);
  const price = cfg.variant.price;
  // The better of the pack discounts that a cart holding this many bottles qualifies for.
  const rateFor = bottles => Object.entries(cfg.packRates).reduce((best,[min,rate]) => bottles>=Number(min)&&rate>best?rate:best, 0);
  const perBottle = bottles => price - Math.floor(price * rateFor(bottles) + 1e-7);
  const amountFor = bottles => bottles * perBottle(bottles);
  root.querySelectorAll('.product-info .review-product-title + .product-price').forEach(value => {value.textContent = money(price);});
  const endpoint = suffix => cfg.root.replace(/\/$/,'') + '/cart/' + suffix;
  const cartEndpoint = cfg.root.replace(/\/$/,'') + '/cart.js';
  const selected = () => Number(radios.find(r => r.checked)?.value) || 0;
  const announce = message => { status.textContent = message; };
  const cartCount = cart => document.querySelectorAll('[data-hw-cart-count]').forEach(n => {const value=String(cart.item_count);if(n.textContent!==value)n.textContent=value;});
  // The store-wide cart drawer (snippets/oc-cart, rendered by this layout) opens with a cart we already read.
  const openCart = cart => {
    if (window.ocCart) return window.ocCart.open(cart);
    location.assign(cfg.root.replace(/\/$/,'') + '/cart');
  };
  const loadCart = async () => {
    const response = await fetch(cartEndpoint, {headers:{Accept:'application/json'},cache:'no-store'});
    if (!response.ok) throw new Error(cfg.strings.cartCheck);
    return response.json();
  };
  const post = async (path,body) => {
    const response = await fetch(endpoint(path), {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || cfg.strings.error);
    return data;
  };
  function marketUrl() {
    const url = new URL(location.href);
    url.searchParams.set('view',cfg.view);
    url.searchParams.delete('country');
    return url.pathname + url.search;
  }
  const marketForm = document.getElementById('oc-hw-market');
  const mobileMenu = document.querySelector('.oc-hw-mobile-nav');
  const mobileMarket = document.querySelector('[data-hw-mobile-market]');
  const desktopMarket = document.querySelector('[data-hw-desktop-market]');
  const mobileHeader = matchMedia('(max-width: 989px)');
  const placeMarket = () => {
    const destination = mobileHeader.matches ? mobileMarket : desktopMarket;
    if (marketForm && destination && marketForm.parentElement !== destination) destination.append(marketForm);
    if (!mobileHeader.matches && mobileMenu) mobileMenu.open = false;
  };
  placeMarket();
  mobileHeader.addEventListener('change',placeMarket);
  mobileMenu?.addEventListener('keydown',event => {
    if (event.key === 'Escape' && mobileMenu.open) {
      mobileMenu.open = false;
      mobileMenu.querySelector('summary').focus();
    }
  });
  const countrySelect = marketForm?.querySelector('[data-hw-country]');
  countrySelect?.addEventListener('change', () => {
    marketForm.querySelector('[data-hw-market-return]').value = marketUrl();
    marketForm.submit();
  });
  if (cfg.requiredCountry && cfg.country !== cfg.requiredCountry && !window.Shopify?.designMode) {
    button.disabled = true;
    if (countrySelect && [...countrySelect.options].some(o => o.value === cfg.requiredCountry)) {
      countrySelect.value = cfg.requiredCountry;
      marketForm.querySelector('[data-hw-market-return]').value = marketUrl();
      marketForm.submit();
    } else announce('This country is not available in the store.');
    return;
  }
  const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`;
  function render() {
    radios.forEach(radio => {
      const bottles = Number(radio.value), node = radio.closest('[data-oc-bottles]');
      node.classList.toggle('kaching-bundles__bar--selected',radio.checked);
      radio.disabled = !cfg.variant.available || busy || uncertain;
      const amount = amountFor(bottles);
      // "You save" and the struck price compare with buying the same bottles one at a time, as the range page did.
      const save = Math.floor((1-amount/(price*bottles))*100);
      const pill = node.querySelector('[data-hw-save]');
      pill.textContent = save>0 ? `You save ${save}%` : '';
      pill.hidden = save<=0;
      const each = node.querySelector('[data-hw-each]');
      each.replaceChildren(document.createTextNode(money(perBottle(bottles))+' '));
      const per = document.createElement('span');per.className='kaching-bundles__bar-price__unit-label';per.textContent='per bottle';each.append(per);
      each.setAttribute('aria-label',money(perBottle(bottles))+' per bottle');
      const reference = node.querySelector('[data-hw-reference]');
      reference.textContent = save>0 ? money(price) : '';
      reference.hidden = save<=0;
      const total=node.querySelector('[data-hw-total]');if(total)total.textContent=`${plural(bottles,'bottle')}, total: ${money(amount)}`;
    });
    const bottles=selected(),amount=bottles?amountFor(bottles):0;
    form.querySelector('[data-hw-variant]').value=String(cfg.variant.id);
    form.querySelector('[name="quantity"]').value=String(bottles||1);
    const plan=form.querySelector('[data-hw-plan]');if(plan)plan.disabled=true;
    const renewal=root.querySelector('[data-hw-renewal]');
    if(renewal&&bottles)renewal.textContent=`One-time purchase: ${money(amount)} for ${plural(bottles,'bottle')}. No recurring charges. One bottle lasts about ${cfg.servingsPerBottle} days at one 1 mL dropper a day. Prices in ${cfg.currency}.`;
    button.disabled=busy||uncertain||!cfg.variant.available||!bottles;
    label.textContent=busy?cfg.strings.adding:cfg.variant.available?cfg.strings.add:cfg.strings.soldOut;
    offerRoot.style.visibility='visible';
    root.dataset.hwMode='once';root.dataset.hwReady=String(!button.disabled);
  }
  radios.forEach(r => r.addEventListener('change',render));
  function lineProperties() {
    const properties={_oc_range_page:cfg.handle,_oc_b12_page:cfg.pageVersion,_oc_market:cfg.country};
    for(const key of ['utm_source','utm_medium','utm_campaign','utm_content','utm_term']){const value=params.get(key);if(value)properties['_'+key]=value.slice(0,150);}
    if(params.get('oc_qa')==='1')properties._oc_qa=cfg.pageVersion;
    return properties;
  }
  const isBottle=line=>line.variant_id===cfg.variant.id&&!line.selling_plan_allocation;
  const bottlesIn=cart=>cart.items.filter(isBottle).reduce((n,line)=>n+line.quantity,0);
  form.addEventListener('submit',async event => {
    event.preventDefault();if(button.disabled||busy||uncertain)return;
    busy=true;announce('');render();
    const bottles=selected(),properties=lineProperties();
    const items=[{id:cfg.variant.id,quantity:bottles,properties}];
    if(params.get('oc_qa')==='1')root.dataset.hwSubmitItems=JSON.stringify(items);
    const ours=line=>isBottle(line)&&Object.keys(line.properties||{}).length===Object.keys(properties).length&&Object.entries(properties).every(([k,v])=>line.properties[k]===v);
    let submitted=false,added=false,before=0;
    try{
      const baseline=await loadCart();
      if(baseline.currency!==cfg.currency)throw new Error('Your currency changed. Refresh the page before adding this pack.');
      before=bottlesIn(baseline);
      submitted=true;
      await post('add.js',{items});
      added=true;
      const cart=await loadCart();
      const lines=cart.items.filter(isBottle),line=cart.items.find(ours),total=bottlesIn(cart);
      const paid=lines.reduce((n,l)=>n+l.final_line_price,0);
      // Every bottle in the cart is priced together, so the cart may never cost more than this page's price for that
      // many bottles. (A discount code that makes it cheaper is fine.)
      const ok=cart.currency===cfg.currency&&!!line&&total===before+bottles&&line.original_price===price&&paid<=amountFor(total);
      if(!ok){
        const fresh=await loadCart(),index=fresh.items.findIndex(ours);
        if(index>=0){const keep=fresh.items[index].quantity-bottles;const restored=await post('change.js',{line:index+1,quantity:Math.max(0,keep)});cartCount(restored);}
        added=false;submitted=false;
        throw new Error('This pack could not be priced correctly, so nothing was added. Please refresh and try again.');
      }
      cartCount(cart);openCart(cart);announce(cfg.strings.added);
      if(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.())window.dataLayer?.push({event:'oc_b12_add_to_cart',page:cfg.pageVersion,bottles,value:amountFor(bottles)/100,plan_type:'one-time',currency:cfg.currency,qa:params.get('oc_qa')==='1'});
    }catch(error){
      // A timeout can come after Shopify accepted the items. Check the saved cart before allowing another
      // click, so a retry cannot double an order.
      if(submitted&&!added){
        try{const cart=await loadCart();added=bottlesIn(cart)>=before+bottles;cartCount(cart);}
        catch{uncertain=true;}
      }
      announce(uncertain?cfg.strings.cartCheck:error instanceof TypeError?cfg.strings.error:error.message||cfg.strings.error);
      if(uncertain||added){const link=document.createElement('a');link.href=cfg.root.replace(/\/$/,'')+'/cart';link.textContent=' View cart';status.append(link);}
    }finally{busy=false;render();}
  });
  document.querySelectorAll('[data-hw-cart]').forEach(button=>button.addEventListener('click',()=>openCart()));
  window.addEventListener('pageshow',e=>{if(e.persisted)location.reload();});
  const loadImage=img=>{if(img?.dataset.src){img.src=img.dataset.src;if(img.dataset.srcset)img.srcset=img.dataset.srcset;delete img.dataset.src;delete img.dataset.srcset;}};
  const formula=root.querySelector('#oc-hw-formula'),feeding=root.querySelector('#oc-hw-feeding'),zoom=root.querySelector('#oc-hw-zoom');
  // Safari before iOS 15.4 has no <dialog>: hide these three pop-ups until opened and open/close them by hand there.
  [formula,feeding,zoom].forEach(d=>{if(!d||typeof d.showModal==='function')return;if(!document.getElementById('oc-dialog-fallback')){const st=document.createElement('style');st.id='oc-dialog-fallback';st.textContent='#oc-hw-formula:not([open]),#oc-hw-feeding:not([open]),#oc-hw-zoom:not([open]){display:none}#oc-hw-formula[open],#oc-hw-feeding[open],#oc-hw-zoom[open]{position:fixed;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);z-index:2147483000;margin:0;max-height:88vh;overflow:auto;box-shadow:0 0 0 100vmax rgba(11,30,57,.7)}';document.head.appendChild(st);}d.showModal=()=>d.setAttribute('open','');d.close=()=>d.removeAttribute('open');});
  const formulaArtwork=root.querySelector('.shop-main-image[data-media-id="oc-b12-10"]')||root.querySelectorAll('.shop-main-image')[3];
  const showFormula=()=>{const img=formula.querySelector('[data-hw-formula-image]');img.src=formulaArtwork.dataset.zoomSrc||formulaArtwork.dataset.src||formulaArtwork.src;img.alt=formulaArtwork.alt;};
  root.querySelectorAll('[data-hw-open]').forEach(button=>button.addEventListener('click',()=>{const dialog=button.dataset.hwOpen==='formula'?formula:feeding;if(dialog===formula)showFormula();else dialog.querySelectorAll('img').forEach(loadImage);dialog.showModal();dialog.querySelector('[data-hw-close]').focus();}));
  [formula,feeding,zoom].forEach(dialog=>{dialog.querySelector('[data-hw-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});});
  root.querySelector('.shop-main-image-wrapper')?.addEventListener('click',e=>{if(e.target.closest('button,a'))return;const active=root.querySelector('.shop-main-image.active');if(!active)return;const img=zoom.querySelector('img');img.src=active.dataset.zoomSrc||active.src;img.alt=active.alt;zoom.showModal();});
  // Keep FAQ paragraphs intact and expose the existing accordion to keyboards.
  root.querySelectorAll('.faq-question').forEach(question=>{const item=question.closest('.faq-item');question.tabIndex=0;question.setAttribute('role','button');const syncExpanded=()=>{const expanded=String(item.classList.contains('active'));if(question.getAttribute('aria-expanded')!==expanded)question.setAttribute('aria-expanded',expanded);};const faqObserver=new MutationObserver(syncExpanded);faqObserver.observe(item,{attributes:true,attributeFilter:['class']});faqObserver.observe(question,{attributes:true,attributeFilter:['aria-expanded']});syncExpanded();question.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();question.click();}});});
  root.querySelectorAll('.shop-thumbnail').forEach((thumb,i)=>{thumb.tabIndex=0;thumb.setAttribute('role','button');thumb.setAttribute('aria-label',`View product image ${i+1}`);thumb.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();thumb.click();}});});
  const gallerySurface=root.querySelector('.shop-main-image-wrapper');
  if(gallerySurface){
    [-1,1].forEach(direction=>{
      const arrow=document.createElement('button');arrow.type='button';
      arrow.className='oc-hw-gallery-arrow '+(direction<0?'prev':'next');
      arrow.setAttribute('aria-label',direction<0?'Previous product image':'Next product image');
      arrow.textContent=direction<0?'‹':'›';
      arrow.addEventListener('click',()=>{
        const dots=[...root.querySelectorAll('.shop-dot')];
        const index=[...root.querySelectorAll('.shop-main-image')].findIndex(img=>img.classList.contains('active'));
        dots[(index+direction+dots.length)%dots.length]?.click();
      });
      gallerySurface.append(arrow);
    });
  }
  render();
})();
